<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

// Selo de estágio do card da lista: nome e cor da coluna do funil, ou Ganho/Perda quando o negócio
// fechou. O desfecho vem antes porque `pipeline_stage` permanece na conversa depois de Ganho ou
// Perda (o quadro exclui por `deal_outcome`, não por estágio). As colunas vêm do store `pipeline`,
// que o ChatList preenche ao montar (`pipeline/fetchStages`). A cor é dado do banco, por isso vai
// em `:style`, como PipelineColumn.vue já faz.
const props = defineProps({
  chat: { type: Object, required: true },
});

const stages = useMapGetter('pipeline/getStages');

const attrs = computed(() => props.chat.custom_attributes || {});

const stage = computed(() => {
  const id = attrs.value.pipeline_stage;
  if (id === undefined || id === null || id === '') return null;
  return (stages.value || []).find(s => String(s.id) === String(id)) || null;
});

const chip = computed(() => {
  const outcome = attrs.value.deal_outcome;
  if (outcome === 'won') return { outcome, emoji: '🏆', color: '#16a34a' };
  if (outcome === 'lost') return { outcome, emoji: '🚫', color: '#6b7280' };
  if (stage.value) {
    return {
      outcome: null,
      label: stage.value.name,
      color: stage.value.color || '#3b82f6',
    };
  }
  return null;
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <span
    v-if="chip"
    data-testid="stage-chip"
    class="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-xxs font-medium bg-n-slate-3 text-n-slate-12 max-w-[11rem]"
    :title="chip.label"
  >
    <span
      data-testid="stage-chip-dot"
      class="h-2 w-2 rounded-full shrink-0"
      :style="{ backgroundColor: chip.color }"
    />
    <span class="truncate">
      <template v-if="chip.outcome === 'won'">
        {{ chip.emoji }} {{ $t('PIPELINE.CARD_CHIP.WON') }}
      </template>
      <template v-else-if="chip.outcome === 'lost'">
        {{ chip.emoji }} {{ $t('PIPELINE.CARD_CHIP.LOST') }}
      </template>
      <template v-else>{{ chip.label }}</template>
    </span>
  </span>
</template>
